import "./EllenwoodServiceArea.module.css";
import Header from "@/reusable_sections/Header";
import EllenwoodHero from "./sections/EllenwoodHero";
import EllenwoodArea from "./sections/EllenwoodArea";
import Services from "./sections/Services";
import PlumbingIssues from "./sections/PlumbingIssues";
import Faq from "./sections/Faq";
import EmergencyCta from "./sections/EmergencyCta";
import Footer from "@/reusable_sections/Footer";
export default function EllenwoodServiceAreaPage() {
  return <div>
      <Header />
      <EllenwoodHero />
      <EllenwoodArea />
      <Services />
      <PlumbingIssues />
      <Faq />
      <EmergencyCta />
      <Footer />
    </div>;
}